import styled, { css } from "styled-components";
import { IPhotoContainer } from "./interface";

const Container = styled.div<IPhotoContainer>`
  border: 0.25px solid var(--main-color);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 4px;

  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  ${(props) => !props.photo && css`
    background-color: var(--input-background-color);
    color: var(--purple-lighter);
    border-color: var(--purple-lighter);
    border-width: 2px;
    font-weight: bold;
  `}

  ${(props) => props.styleInline && props.styleInline}
`;

export const TooltipPhoto = styled.div`
  position: relative;
  span{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      min-width: 10rem;
      max-width: 12rem;
      width: max-content;

      padding: 0.125rem;

      background: var(--modal-body);
      border: 1px solid var(--border-color);


      border-radius: 8px;
      opacity: 0;
      transition: 100ms;
      visibility: hidden;
      position: absolute;
      /* transform: translateX(-50%); */
      text-align: center;
      z-index: 500;

      bottom: 0;
      left: 0;

      div.texts{
        font-size: 0.8rem;
        color: var(--default-color-font);
        margin: 2px;
        text-align: start;

        &.name{
          font-weight: bold;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      /* &::before{
          content: '';
          border-style: solid;
          border-color: var(--border-color) transparent;
          border-width: 8px 8px 0 8px;
          top: 100%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
      } */
      /* &:hover{
          opacity: 0 !important;
          visibility: hidden !important;
      } */
  }
    &:hover span{
        opacity: 1;
        visibility: visible;
    }
`;

export default Container;
